import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { StatusBar } from '@ionic-native/status-bar';

import { Storage } from '@ionic/storage';

import { LoginPage } from '../../pages/login/login';
import { RegisterTermsPage } from '../../pages/register-terms/register-terms';
import { AuthProvider } from '../../providers/auth';

import { BusinessMainPage } from '../../pages/business-main/business-main';

import { Globals } from '../../providers/globals';

@Component({
  selector: 'page-business-register',
  templateUrl: 'business-register.html',
})
export class BusinessRegisterPage {
	registerForm : FormGroup;
	isRegistering: boolean = false;
	recievedError: boolean = false;
	errorText: any;

	constructor(
		public globals: Globals,
		public statusBar: StatusBar, 
		public navCtrl: NavController, 
		public storage: Storage,
		public authProvider: AuthProvider,  	
		public navParams: NavParams,
		public formBuilder: FormBuilder,) {

		this.registerForm = this.formBuilder.group({
			"BusinessName":  ['', Validators.compose([Validators.required, Validators.minLength(5)]) ],			
		  	"Email":  ['', Validators.compose([Validators.required, Validators.email])],
		  	"Password":  ['', Validators.compose([Validators.required, Validators.minLength(6)]) ],  		  	
		});
	}


	ionViewCanLeave(): boolean{
		if(this.isRegistering){
			return false;
		}else{
			return true;
		}
	}		

	ionViewDidLoad() {
		console.log('ionViewDidLoad BusinessRegisterPage');
	}

	viewTerms(){
		this.navCtrl.push(RegisterTermsPage);
	}


	register(){
	    if(this.isRegistering) return;

	    this.isRegistering = true;
	    this.recievedError = false;

	    this.authProvider.registerBusiness(this.registerForm.value)
	    .then( data => {
	        this.globals.registeredAsBusiness = true;

	        this.login();

	    })
	    .catch( error => {
	        this.isRegistering = false;
	        this.recievedError = true;

	        if(error.json().ModelState.BadEmail){
	        	this.errorText = error.json().ModelState.BadEmail[0];
	        }else{
	        	this.errorText = error.json().Message;
	        }
	        
	        console.log(error)
	    })
	}

	moveToLogin(){	
		this.navCtrl.push(LoginPage);
	}

	login(){
		let body = {
			"grant_type": 'password',
			"username":  this.registerForm.value.Email,
			"password":  this.registerForm.value.Password,
		};

	    this.authProvider.login(body)
	    .then( data => {        
	    	this.isRegistering =false;

            this.navCtrl.setRoot(BusinessMainPage);              
	    })
	    .catch( error => {
	        this.isRegistering = false;
	        this.recievedError = true;

	        console.log(error)
	    })

	}  

}



// WEBPACK FOOTER //
// ./src/pages/business-register/business-register.ts